import { itixCartController } from '@x-com/pwitixcomm/tslib/itix.cart.ts'
import Alpine from 'alpinejs'

export const initOrderArticle = () => {
    Alpine.data('orderArticle', ({ successMsg }) => ({
        init() {
            if (this.$el instanceof HTMLFormElement) {
                const form = this.$el

                form.onsubmit = async (e) => {
                    e.preventDefault()
                    form.querySelectorAll('.alert').forEach((el) => el.remove())
                    const data = await itixCartController.addArticle(new FormData(form))

                    if (data.status === 'OK') {
                        form.prepend(createAlertElement(successMsg, 'info'))
                    } else {
                        form.prepend(createAlertElement(data.message, 'error'))
                    }
                }
            }
        },
    }))
}

const createAlertElement = (message: string, type: 'error' | 'info') => {
    const errorElement = document.createElement('p')
    errorElement.classList.add('alert')
    errorElement.classList.add(type === 'error' ? 'alert--error' : 'alert--success')
    errorElement.innerHTML = message
    return errorElement
}
